module.exports = __webpack_public_path__ + "static/media/SUB.5b30c311.svg";